import { render, staticRenderFns } from "./PricingRefund.vue?vue&type=template&id=f8e394a8&scoped=true"
import script from "./PricingRefund.vue?vue&type=script&lang=js"
export * from "./PricingRefund.vue?vue&type=script&lang=js"
import style0 from "./PricingRefund.vue?vue&type=style&index=0&id=f8e394a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e394a8",
  null
  
)

export default component.exports